import * as ReSpec from "../src/respec.js";

const modules = [
  // order is significant
  import("../src/core/location-hash.js"),
  import("../src/core/l10n.js"),
  import("../src/aom/defaults.js"),
  import("../src/core/style.js"),
  import("../src/aom/style.js"),
  import("../src/core/data-include.js"),
  import("../src/core/markdown.js"),
  import("../src/core/reindent.js"),
  import("../src/core/title.js"),
  import("../src/aom/headers.js"),
  import("../src/aom/abstract.js"),
  import("../src/core/data-transform.js"),
  import("../src/core/data-abbr.js"),
  import("../src/core/algorithms.js"),
  import("../src/core/inlines.js"),
  import("../src/aom/conformance.js"),
  import("../src/core/dfn.js"),
  import("../src/core/pluralize.js"),
  import("../src/core/examples.js"),
  import("../src/core/issues-notes.js"),
  import("../src/core/best-practices.js"),
  import("../src/core/figures.js"),
  import("../src/core/biblio.js"),
  import("../src/core/link-to-dfn.js"),
  import("../src/core/data-cite.js"),
  import("../src/core/xref-headings.js"),
  import("../src/core/render-biblio.js"),
  import("../src/core/contrib.js"),
  import("../src/core/sections.js"),
  import("../src/core/fix-headers.js"),
  import("../src/core/structure.js"),
  import("../src/core/informative.js"),
  import("../src/core/id-headers.js"),
  import("../src/ui/save-html.js"),
  import("../src/ui/about-respec.js"),
  import("../src/core/seo.js"),
  import("../src/core/highlight.js"),
  import("../src/core/list-sorter.js"),
  import("../src/core/highlight-vars.js"),
  import("../src/core/data-type.js"),
  import("../src/core/anchor-expander.js"),
  import("../src/core/dfn-panel.js"),
  import("../src/core/custom-elements/index.js"),
  import("../src/core/dfn-contract.js"),
  /* Linter must be the last thing to run */
  import("../src/core/linter-rules/check-charset.js"),
  import("../src/core/linter-rules/no-dfn-in-abstract.js"),
  import("../src/core/linter-rules/check-punctuation.js"),
  import("../src/core/linter-rules/local-refs-exist.js"),
  import("../src/core/linter-rules/no-headingless-sections.js"),
  import("../src/core/linter-rules/no-unused-vars.js"),
  import("../src/core/linter-rules/privsec-section.js"),
  import("../src/core/linter-rules/no-http-props.js"),
];

Promise.all(modules)
  .then(plugins => ReSpec.run(plugins))
  .catch(err => console.error(err));
